import Nullstack from 'nullstack';
export default function IconCurrencyYen({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-yen",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v-7l-5 -7m10 0l-5 7"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "17",
    x2: "16",
    y2: "17"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "13",
    x2: "16",
    y2: "13"
  }), " ");
}